  
  /* 
    Author: Srinivas P
    Date: 04/12/2019
    Issue Description: Once the Payroll Preferences are set, if you logout and login again, it is again taking back to Get Started
    Issue Id:PL-1981
    SearchString:GetStarted Issue
  */ 
  
  
  
  <template>
  <div class="main-container">
    <div v-if="showIntro && !isGetStartedClicked">
      <tl-header type="h1">
        <div>Payroll Preferences</div>
      </tl-header>
      <div class="row-container center">
        <div class="company-info">
          <img class="image" src="@/assets/settings.svg" />
          <!-- <div @click="goToPreferencesPage"><img class="closeImage" src="@/assets/close.png" /></div> -->
          <div class="fontStyle">
            <br />
            <br />
            <span>
              You can set your Payroll preferrences, Pay computations,
              Salary components, Salary structures and payslip data.
            </span>
            <br />
            <span>Create a payroll cycle by selecting Payroll Frequency.</span>
            <br />
            <br />
            <span>
              You can create Salary components as many as you want
              and select which you need to show them on Payslips.
              You can select Payslip format from the available templates.
            </span>
            <br />
            <span>preferrences from advance settings in the same section</span>
            <div class="divider"></div>
            <br />
            <br />
            <btn text="Get Started" type="secondary" @click="goToPreferencesPage" />
          </div>
        </div>
      </div>
      <bottom-action-container class="placeAtEnd">
        <btn-skip @navClicked="skip"></btn-skip>
      </bottom-action-container>
    </div>
    <div v-else>
      <preferences @displayIntro="goToIntro" />
    </div>
  </div>
</template>

  <script>
import Preferences from "./Preferences.vue";
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  name: "PreferencesIntro",
  data() {
    return {
      showIntro: true,
      isGetStartedClicked: false
    };
  },
  components: {
    Preferences
  },
  computed: {
    ...mapState({
      getPaycycleData: state =>
        state.onboard.settings.payroll_cycle.entityWiseData,
      getPayComputationData: state =>
        state.onboard.settings.payroll_computation.entityWiseData
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      } else {
        return this.getleid(0);
      }
    }
  },
  mounted() {
    this.getAllPayData();
  },
  activated() {
    this.getAllPayData();
  },
  methods: {
    ...mapActions({
      act_fetchAll: "onboard/settings/payroll_cycle/fetchAll",
      act_fetchAll_paycomputation:
        "onboard/settings/payroll_computation/fetchAll"
    }),
    skip() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/paygroup`
      });
    },
    // Start of GetStarted method
    async getAllPayData() {
      try {
        await this.act_fetchAll(this.le_id);
        await this.act_fetchAll_paycomputation(this.le_id);
        if (
          this.getPaycycleData[this.le_id] ||
          this.getPayComputationData[this.le_id]
        ) {
          this.showIntro = false;
        } else {
          this.showIntro = true;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    //End of GetStarted method
    goToIntro() {
      this.showIntro = false;
    },
    goToPreferencesPage() {
      this.isGetStartedClicked = true;
      this.showIntro = false;
    }
  }
};
</script>

  <style scoped>
.company-info {
  display: flex;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  align-items: flex-start;
  position: relative;
  width: 100%;
}

.closeImage {
  position: absolute;
  float: right;
  top: 10px;
  cursor: pointer;
  right: 10px;
}

.image {
  margin-top: 30px;
}

.building {
  width: 56px;
  height: 58px;
  object-fit: contain;
  margin: 25px 0 0 129px;
}

.fontStyle {
  margin-left: 20px;
  font-family: Montserrat;
  font-size: 16px;
  color: #404040;
}

.divider {
  color: #34c0be;
  border-bottom: 2px solid #34c0be;
  width: 60%;
  margin: 30px 0 0 5px;
}

.placeAtEnd {
  margin-top: 200px;
}
</style>
